export default "__VITE_ASSET__C8cew3hN__"